// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiAppeal {
    static getAttributeTypeMap() {
        return MedicalBiAppeal.attributeTypeMap;
    }
}
MedicalBiAppeal.discriminator = undefined;
MedicalBiAppeal.additionalProperties = false;
MedicalBiAppeal.attributeTypeMap = [
    {
        "name": "available",
        "baseName": "available",
        "type": "string"
    },
    {
        "name": "contactFax",
        "baseName": "contactFax",
        "type": "string"
    },
    {
        "name": "contactOrg",
        "baseName": "contactOrg",
        "type": "string"
    },
    {
        "name": "contactPhone",
        "baseName": "contactPhone",
        "type": "string"
    },
    {
        "name": "numberAvailable",
        "baseName": "numberAvailable",
        "type": "string"
    },
    {
        "name": "requiredDocuments",
        "baseName": "requiredDocuments",
        "type": "string"
    },
    {
        "name": "submissionDeadline",
        "baseName": "submissionDeadline",
        "type": "string"
    },
    {
        "name": "turnaroundTime",
        "baseName": "turnaroundTime",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiAppeal.js.map